<template>
  <div id="maincontent" class="not-found">
    <div class="image"></div>
    <div class="text">
      <h1 class="text-title">whoops</h1>
      <h4 v-if="is404" class="text-number">404 PAGE NOT FOUND</h4>
      <slot name="main-text">
        <p class="text-desc">
          Maaf, halaman yang anda cari tidak di temukan. Tapi jangan khawatir, Anda selalu bisa kembali ke sini.
        </p>
      </slot>
      <router-link class="text-button" to="/">Kembali ke home</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-not-found',
  props: {
    is404: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  metaInfo() {
    const meta = {
      title: this.$store.state.defaultTitle,
      meta: [
        { name: 'title', content: this.$store.state.defaultTitle },
        { name: 'description', content: this.$store.state.defaultDescription },
      ],
    };

    if (this.is404) {
      return meta;
    }
  },
  mounted() {
    setTimeout(() => {
      window.prerenderReady = true;
    }, 2000);
  },
};
</script>
